import { doc, getDoc, setDoc } from "firebase/firestore";
import { db, storage } from "../config/firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import store from "../store";
import { setButtonLoading, setLandingData } from "../store/slices/landingSlice";


export const updateLanding = async ({ media, thumbnailURL, payload }) => {
  try {
    store.dispatch(setButtonLoading(true));

    if (!media) {
      throw new Error("No media file provided");
    }

    const mediaRef = ref(storage, `media/${media.name}`);
    const videoStorageRef = ref(storage, "landing-video");

    await uploadBytes(mediaRef, media);
    const mediaURL = await getDownloadURL(mediaRef);

    const mediaMetadata = {
      contentType: media.type,
    };

    await uploadBytes(videoStorageRef, media, mediaMetadata);
    const videoURL = await getDownloadURL(videoStorageRef);

    const landingDocRef = doc(db, "landing", "only-object");

    await setDoc(
      landingDocRef,
      {
        landingVideo: videoURL,
        thumbnailURL: thumbnailURL,
        mediaType: media?.type,
      },
      { merge: true }
    );

    await getLanding();

    return true;
  } catch (error) {
    console.error("Error updating landing:", error);
    return false;
  } finally {
    store.dispatch(setButtonLoading(false));
  }
};


export const getLanding = async () => {
  try {
    const docRef = doc(db, "landing", "only-object");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      store.dispatch(setLandingData(docSnap.data()));
    } else {
      store.dispatch(setLandingData(null));
    }
    return true;
  } catch (error) {
    console.log("Get Settings Error:", error.message);
  }
};
